import { User, Phone, Globe2, CalendarDays } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { useSettings } from "@/context/SettingsContext";
import { AuthImage } from "@/components/AuthImage";

const Row = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-start gap-3 border-b border-border py-3 last:border-0">
    <Icon className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
    <div className="min-w-0">
      <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">{label}</p>
      <p className="break-words font-semibold" data-testid={testId}>{value}</p>
    </div>
  </div>
);

export const MemberCard = ({ user }) => {
  const { t } = useLang();
  const { settings } = useSettings();
  return (
    <div className="overflow-hidden rounded-2xl border border-border bg-card" data-testid="dashboard-member-card">
      <div className="flex items-center justify-between bg-primary px-6 py-4 text-primary-foreground">
        <span className="text-sm font-bold uppercase tracking-widest">{t("member_card")}</span>
        <span className="text-sm font-bold">{settings?.org_name}</span>
      </div>
      <div className="grid gap-6 p-6 sm:grid-cols-5">
        <div className="sm:col-span-2">
          <AuthImage path={user.id_photo_path} alt="ID" data-testid="dashboard-id-photo" className="pointer-events-none aspect-[4/3] w-full select-none rounded-xl border border-border bg-muted object-cover" draggable={false} />
        </div>
        <div className="sm:col-span-3">
          <Row icon={User} label={t("full_name")} value={user.full_name} testId="dashboard-full-name" />
          <Row icon={Phone} label={t("phone")} value={user.phone} testId="dashboard-phone" />
          <Row icon={Globe2} label={t("country")} value={user.country} testId="dashboard-country" />
          <Row icon={CalendarDays} label={t("registered_on")} value={new Date(user.created_at).toLocaleDateString()} testId="dashboard-date" />
        </div>
      </div>
    </div>
  );
};
